import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Handler from "../../Helpers/Components/Handler";
import { reloadWindowToPath } from "../../Helpers/Utils";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "../../Helpers/Components/Modal";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Select from 'react-select'
import CollapseSection from './Collapse'

const Verification = () => {
    const { id } = useParams()
    const [details, setDetails] = useState({})
    const [totalDays, setTotalDays] = useState(0)
    const [point, setPoint] = useState()
    const [refund, setRefund] = useState(0)
    const [open, setOpen] = useState(false);
    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const [open4, setOpen4] = useState(false);
    const [excess, setExcess] = useState(0)
    const [loading, setLoading] = useState(false)
    const [dl, setDl] = useState({})
    const [aadhaar, setAadhaar] = useState({})
    const [otherCharges, setOtherCharges] = useState(0)
    const [leadList, setLeadList] = useState([])
    const [passport, setPassport] = useState({})
    const [totalAmount, setTotalAmount] = useState(0)
    const [extraPay, setExtraPay] = useState(false)
    const contentRef = useRef(null);
    const [preview, setPreview] = useState(false)
    const [person, setPerson] = useState({ delivery: '', pickup: '', booked: '', btb: '' })
    const [verificationRemarks, setVerificationRemarks] = useState("")
    const [refundAt, setRefundAt] = useState("")
    const [daysCount, setDaysCount] = useState([])
    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const getBillingMonths = (from, to) => {
        const getBillingMonthDate = (date, isEnd = false) => {
            const d = new Date(date);
            const cutoff = new Date(d);
            cutoff.setDate(25);
            cutoff.setHours(18, 0, 0, 0);
            if (!isEnd) {
                if (d >= cutoff) return new Date(d.getFullYear(), d.getMonth() + 1, 1);
                return new Date(d.getFullYear(), d.getMonth(), 1);
            }
            if (d > cutoff) return new Date(d.getFullYear(), d.getMonth() + 1, 1);
            return new Date(d.getFullYear(), d.getMonth(), 1);
        };
        const start = getBillingMonthDate(from, false);
        const end = getBillingMonthDate(to, true);
        const months = [];
        const current = new Date(start);
        while (current <= end) {
            months.push({ month: `01-${String(current.getMonth() + 1).padStart(2, "0")}-${current.getFullYear()}` });
            current.setMonth(current.getMonth() + 1);
        }
        return months;
    };
    const getDetails = async () => {
        const response = await Handler({ method: 'get', url: `/booking/detail/${id}` })
        if (response?.success) {
            const data = response?.data
            setDetails({ ...data, ...(data?.booking?.stageHistory?.length ? { stageHistory: data?.booking?.stageHistory?.filter(element => element?.staffId)?.length ? data?.booking?.stageHistory?.filter(element => element?.staffId) : [] } : {}) })
            const proof = data?.booking?.proofCollected ? data?.booking?.proofCollected : []
            const collected = []
            proof?.map((element) => {
                if (element === "dl") {
                    collected?.push("Driving License")
                } else if (element === "aadhaar") {
                    collected?.push("Aadhaar Card")
                } else if (element === "passport") {
                    collected?.push("Passport")
                } else if (element === "voter") {
                    collected?.push("Voter ID")
                } else if (element === "familyCard") {
                    collected?.push("Family Card")
                } else {
                    collected?.push(element)
                }
            })
            const excess = Number(data?.booking?.excess?.kmCharges || 0) + Number(data?.booking?.excess?.fuelCharges || 0) + Number(data?.booking?.excess?.timeCharges || 0)
            const excessCharges = data?.booking?.excessCharges?.length ? data?.booking?.excessCharges?.reduce((acc, cur) => acc + Number(cur?.amount || 0), 0) : 0
            setExcess(excess)
            setOtherCharges(excessCharges)
            setDl(data?.customer?.kyc?.length ? data?.customer?.kyc?.find(element => element?.type === "dl") : {})
            setAadhaar(data?.customer?.kyc?.length ? data?.customer?.kyc?.find(element => element?.type === "aadhaar") : {})
            setPassport(data?.customer?.kyc?.length ? data?.customer?.kyc?.find(element => element?.type === "passport") : {})
            let point = 0
            let totalDays = 0
            if (data?.booking?.totalDays) {
                totalDays = Math.floor(data?.booking?.totalDays)
                setTotalDays(Math.floor(data?.booking?.totalDays))
                point = Math.round((data?.booking?.totalDays % 1) * 10)
                setPoint({ value: (data?.booking?.totalDays % 1), label: (data?.booking?.totalDays % 1) })
            } else {
                let diff = ((new Date(data?.booking?.pickupDetails?.pickup).getTime() - new Date(data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600;
                if (Math.ceil(diff / 12) / 2 == 0.5) {
                    setTotalDays(1);
                    totalDays = 1
                    setPoint({ label: 0, value: 0 })
                    point = 0
                } else {
                    setTotalDays(Math.floor(Math.ceil(diff / 12) / 2));
                    totalDays = Math.floor(Math.ceil(diff / 12) / 2)
                    if (Math.ceil(diff / 12) % 2 !== 0) {
                        let to = new Date(data?.booking?.pickupDetails?.pickup)
                        to?.setHours(new Date(data?.booking?.pickupDetails?.pickup)?.getHours() - 2)
                        let diff1 = ((to?.getTime() - new Date(data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600
                        if (Math.ceil(diff1 / 12) % 2 !== 0) {
                            setPoint({ label: 0.5, value: 0.5 })
                            point = 0.5
                        } else {
                            setPoint({ label: 0, value: 0 })
                            point = 0
                        }
                    } else {
                        setPoint({ label: 0, value: 0 })
                        point = 0
                    }
                }
            }

            let totalAmount = ((Number(data?.booking?.rentalFee || 0) - Number(data?.booking?.offerPerDay || 0)) * Number(response?.data?.booking?.totalDays ? response?.data?.booking?.totalDays : (totalDays + point || 0))) + (response?.data?.booking?.totalDays ? 0 : point === 0.5 ? ((Number(data?.booking?.rentalFee || 0) / 2) - Number(data?.booking?.halfDayOffer || 0)) : 0) || "0"
            setTotalAmount(totalAmount)
            let excessCharge = ((Number(data?.booking?.fastTag?.start || 0) - Number(data?.booking?.fastTag?.end || 0)) >= 0) ? (Number(data?.booking?.fastTag?.start || 0) - Number(data?.booking?.fastTag?.end || 0)) : 0
            let refund = (
                (Number(data?.booking?.securityDeposit || 0)) -
                    (
                        Number(data?.booking?.excessCharges?.length ? data?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0)
                        + (Number(data?.booking?.excess?.fuelCharges || 0) + Number(data?.booking?.excess?.kmCharges || 0) + Number(data?.booking?.excess?.timeCharges || 0))
                        + excessCharge
                    ) >= 0 ? ((Number(data?.booking?.securityDeposit || 0)) -
                        (
                            Number(data?.booking?.excessCharges?.length ? data?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0)
                            + (Number(data?.booking?.excess?.fuelCharges || 0) + Number(data?.booking?.excess?.kmCharges || 0) + Number(data?.booking?.excess?.timeCharges || 0))
                            + excessCharge
                        )) : ((
                            Number(data?.booking?.excessCharges?.length ? data?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0)
                            + (Number(data?.booking?.excess?.fuelCharges || 0) + Number(data?.booking?.excess?.kmCharges || 0) + Number(data?.booking?.excess?.timeCharges || 0))
                            + excessCharge
                        ) - (Number(data?.booking?.securityDeposit || 0)))
            )
            if ((Number(data?.booking?.securityDeposit || 0)) -
                (
                    Number(data?.booking?.excessCharges?.length ? data?.booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0)
                    + (Number(data?.booking?.excess?.fuelCharges || 0) + Number(data?.booking?.excess?.kmCharges || 0) + Number(data?.booking?.excess?.timeCharges || 0))
                    + excessCharge
                ) < 0) {
                setExtraPay(true)
            }
            setRefund(refund + Number(data?.booking?.refund?.offer || 0))
            const daysCount = getBillingMonths(data?.booking?.deliveryDetails?.delivery, data?.booking?.pickupDetails?.pickup)
            if (daysCount?.length === 1) {
                setDaysCount([{ month: daysCount[0]?.month, days: data?.booking?.totalDaysCount }])
            } else {
                setDaysCount(daysCount)
            }
        } else {
            reloadWindowToPath(`/booking/1`)
        }
    }
    const verify = async () => {
        if (daysCount?.length && daysCount?.reduce((total, num) => total + Number(num?.days), 0) !== Number(details?.booking?.totalDaysCount)) return toast.error("Dates don't match")
        const refundNeeded = Number(details?.booking?.refund?.amount || 0) > 0
        const refundAtValue = refundAt || details?.booking?.refund?.at
        if (refundNeeded && !refundAtValue) return toast.error("Refund At is required")
        setLoading(true);
        const response = await Handler({ url: `/booking/verify/${id}`, data: { ...(refundNeeded ? { refundAt: new Date(refundAtValue).toISOString() } : {}), daysCount, ...verificationRemarks ? { verificationRemarks } : {}, deliveryBy: person?.delivery?.value, pickupBy: person?.pickup?.value, bookedBy: person?.booked?.value }, method: 'PATCH' })
        if (response?.success) {
            setTimeout(() => { reloadWindowToPath(`/booking/view/${id}`) }, 1500);
            toast.success(response?.message)
        } else {
            setLoading(false)
            toast.error(response?.message)
        }
    }
    const correction = async () => {
        if (!verificationRemarks) {
            toast.error("Remarks is required")
            return
        }
        setLoading(true)
        const response = await Handler({ url: `/booking/correction/${id}`, data: { remarks: verificationRemarks }, method: 'PATCH' })
        if (response?.success) {
            setTimeout(() => {
                reloadWindowToPath(`/booking/view/${id}`)
            }, 1500);
            toast.success(response?.message)
        } else {
            setLoading(false)
            toast.error(response?.message)
        }
    }
    const getLeadList = async () => {
        const response = await Handler({ method: "get", url: `/booking/lead-list`, })
        if (response?.success) {
            const options = response?.data?.length ? response?.data?.map((element) => { return { label: element?.name?.toUpperCase(), value: element?.leadId } }) : []
            setLeadList(options)
            if (details?.stageHistory?.length) {
                const delivery = details?.booking?.stageHistory?.find(element => element?.stage === "Ongoing")
                const pickup = details?.booking?.stageHistory?.find(element => element?.stage === "Completed")
                const booked = details?.booking?.stageHistory?.find(element => element?.stage === "Booked")
                setPerson({
                    delivery: options?.find(element => element?.value === delivery?.staffId),
                    pickup: options?.find(element => element?.value === pickup?.staffId),
                    booked: options?.find(element => element?.value === booked?.staffId),
                    btb: options?.find(element => element.value === details?.booking?.lead?.staffId)
                })
            }
        } else {
            setLeadList([])
        }
    }
    useEffect(() => {
        getDetails()
    }, [id])
    useEffect(() => {
        getLeadList()
    }, [details])
    return (
        <React.Fragment>
            <Modal centered={true} header="Summary" size={''} onShow={preview} footerClassname={'justify-content-center'} toggle={() => setPreview(false)} overlayToggle={() => setPreview(false)}>
                <div className="mx-2">
                    <div className="d-flex align-items-center justify-content-between cursor-pointer modalHead" onClick={() => setOpen(prev => !prev)}>
                        <span >Pre-Booking Details</span>
                        <span>
                            {open ? " " : <span>₹ {Number(totalAmount || 0) + Number(details?.booking?.deliveryDetails?.price || 0) + Number(details?.booking?.pickupDetails?.price || 0) + Number(details?.booking?.securityDeposit || 0)}</span>}
                            {<i className={`${open ? "rotate" : ""} fa-solid fa-angle-down ms-2`}></i>}
                        </span>
                    </div>
                    {/* <div className="smooth-collapse" style={{ height: open ? contentRef.current?.scrollHeight : 0 }}> */}
                    <CollapseSection open={open}>
                        <div ref={contentRef} className="amount-inner">
                            <div className="amount-divider"><span className="itemName">Rental Fee</span><span className="">₹ {Number(totalAmount || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Delivery Fee</span><span className="">₹ {Number(details?.booking?.deliveryDetails?.price || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Pickup Fee</span><span className="">₹ {Number(details?.booking?.pickupDetails?.price || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Security Deposit</span><span className="">₹ {Number(details?.booking?.securityDeposit || 0)}</span></div>
                            <div className="horizontal-line" />
                            <div className="amount-divider"><span className="totalAmount">Total Amount</span><span className="totalAmount">₹ {Number(totalAmount || 0) + Number(details?.booking?.deliveryDetails?.price || 0) + Number(details?.booking?.pickupDetails?.price || 0) + Number(details?.booking?.securityDeposit || 0)}</span></div>
                        </div>
                    </CollapseSection>
                    {/* </div> */}

                    <div className="d-flex align-items-center justify-content-between cursor-pointer modalHead" onClick={() => setOpen1(prev => !prev)}>
                        <span >Excess Amount Details</span>
                        <span>
                            {open1 ? " " : <span>₹ {Number(excess || 0) + Number(otherCharges || 0)}</span>}
                            {<i className={`${open1 ? "rotate" : ""} fa-solid fa-angle-down ms-2`}></i>}
                        </span>
                    </div>
                    {/* <div className="smooth-collapse" style={{ height: open1 ? contentRef.current?.scrollHeight : 0 }}> */}
                    <CollapseSection open={open1}>
                        <div ref={contentRef} className="amount-inner">
                            <div className="amount-divider"><span className="itemName">Excess KM Charges</span><span className="">₹ {Number(details?.booking?.excess?.kmCharges || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Excess Fuel Charges</span><span className="">₹ {Number(details?.booking?.excess?.fuelCharges || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Excess Time Charges</span><span className="">₹ {Number(details?.booking?.excess?.timeCharges || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Over Speed</span><span className="">₹ {Number((details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "fine")?.amount || 0) : 0))}</span></div>
                            <div className="amount-divider"><span className="itemName">Damage Charges</span><span className="">₹ {Number((details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "damage")?.amount || 0) : 0))}</span></div>
                            <div className="horizontal-line" />
                            <div className="amount-divider"><span className="totalAmount">Total Amount</span><span className="totalAmount">₹ {Number(excess || 0) + Number(otherCharges || 0)}</span></div>
                        </div>
                    </CollapseSection>

                    <div className="d-flex align-items-center justify-content-between cursor-pointer modalHead" onClick={() => setOpen2(prev => !prev)}>
                        <span >{!extraPay ? "Refund" : "Additional"} Payment</span>
                        <span>
                            {open2 ? " " : <span>₹ {Number(refund || 0)}</span>}
                            {<i className={`${open2 ? "rotate" : ""} fa-solid fa-angle-down ms-2`}></i>}
                        </span>
                    </div>
                    {/* <div className="smooth-collapse" style={{ height: open2 ? contentRef.current?.scrollHeight : 0 }}> */}
                    <CollapseSection open={open2}>
                        <div ref={contentRef} className="amount-inner">
                            <div className="amount-divider"><span className="itemName">Security Deposit</span><span className="">₹ {Number(details?.booking?.securityDeposit || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Excess KM Charges</span><span className="">₹ {Number(details?.booking?.excess?.kmCharges || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Excess Fuel Charges</span><span className="">₹ {Number(details?.booking?.excess?.fuelCharges || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Excess Time Charges</span><span className="">₹ {Number(details?.booking?.excess?.timeCharges || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Over Speed</span><span className="">₹ {Number((details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "fine")?.amount || 0) : 0))}</span></div>
                            <div className="amount-divider"><span className="itemName">Damage Charges</span><span className="">₹ {Number((details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "damage")?.amount || 0) : 0))}</span></div>
                            <div className="amount-divider"><span className="itemName">Fastag Charges</span><span className="">₹ {Number(((Number(details?.booking?.fastTag?.start || 0) - Number(details?.booking?.fastTag?.end || 0)) >= 0) ? (Number(details?.booking?.fastTag?.start || 0) - Number(details?.booking?.fastTag?.end || 0)) : 0)}</span></div>
                            <div className="horizontal-line" />
                            <div className="amount-divider"><span className="totalAmount">{!extraPay ? "Refund Amount" : "Additional pay"}</span><span className="totalAmount">₹ {Number(refund || 0)}</span></div>
                        </div>
                    </CollapseSection>
                    {/* </div> */}

                    <div className="d-flex align-items-center justify-content-between cursor-pointer modalHead" onClick={() => setOpen3(prev => !prev)}>
                        <span >Cost To Company</span>
                        <span>
                            {open3 ? " " : <span>₹ {Number(totalAmount || 0) + Number(details?.booking?.deliveryDetails?.price || 0) + Number(details?.booking?.pickupDetails?.price || 0) + Number(excess || 0) + (extraPay ? Number(refund || 0) : 0) + (Number((details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "fine")?.amount || 0) : 0))) + (Number((details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "damage")?.amount || 0) : 0)))}</span>}
                            {<i className={`${open3 ? "rotate" : ""} fa-solid fa-angle-down ms-2`}></i>}
                        </span>
                    </div>
                    {/* <div className="smooth-collapse" style={{ height: open3 ? contentRef.current?.scrollHeight : 0 }}> */}
                    <CollapseSection open={open3}>
                        <div ref={contentRef} className="amount-inner">
                            <div className="amount-divider"><span className="itemName">Rental Fee</span><span className="">₹ {Number(totalAmount || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Delivery Fee</span><span className="">₹ {Number(details?.booking?.deliveryDetails?.price || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Pickup Fee</span><span className="">₹ {Number(details?.booking?.pickupDetails?.price || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Excess Fee</span><span className="">₹ {Number(excess || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Over Speed</span><span className="">₹ {Number((details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "fine")?.amount || 0) : 0))}</span></div>
                            <div className="amount-divider"><span className="itemName">Damage Fee</span><span className="">₹ {Number((details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "damage")?.amount || 0) : 0))}</span></div>
                            {extraPay ? <div className="amount-divider"><span className="itemName">Additional pay</span><span className="">₹ {Number(refund || 0)}</span></div> : ""}
                            <div className="horizontal-line" />
                            <div className="amount-divider"><span className="totalAmount">Total Amount</span><span className="totalAmount">₹ {Number(totalAmount || 0) + Number(details?.booking?.deliveryDetails?.price || 0) + Number(details?.booking?.pickupDetails?.price || 0) + (Number((details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "fine")?.amount || 0) : 0))) + Number(excess || 0) + (extraPay ? Number(refund || 0) : 0) + (Number((details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "damage")?.amount || 0) : 0)))}</span></div>
                        </div>
                    </CollapseSection>
                    {/* </div> */}

                    <div className="d-flex align-items-center justify-content-between total-amount-card cursor-pointer modalHead" onClick={() => setOpen4(prev => !prev)}>
                        <span className="totalAmount">Total Amount</span>
                        <span className="totalAmount">
                            {open4 ? " " : <span>₹ {Number(totalAmount || 0) + Number(details?.booking?.deliveryDetails?.price || 0) + Number(details?.booking?.pickupDetails?.price || 0) + Number(details?.booking?.securityDeposit || 0) + Number(excess || 0) + Number(otherCharges || 0) + (extraPay ? Number(refund || 0) : 0)}</span>}
                            {<i className={`${open4 ? "rotate" : ""} fa-solid fa-angle-down ms-2`}></i>}
                        </span>
                    </div>
                    {/* <div className="smooth-collapse" style={{ height: open4 ? contentRef.current?.scrollHeight : 0 }}> */}
                    <CollapseSection open={open4}>
                        <div ref={contentRef} className="amount-inner">
                            <div className="amount-divider"><span className="itemName">Rental Fee</span><span className="">₹ {Number(totalAmount || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Delivery Fee</span><span className="">₹ {Number(details?.booking?.deliveryDetails?.price || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Pickup Fee</span><span className="">₹ {Number(details?.booking?.pickupDetails?.price || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Security Deposit</span><span className="">₹ {Number(details?.booking?.securityDeposit || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Excess Charges</span><span className="">₹ {Number(excess || 0)}</span></div>
                            <div className="amount-divider"><span className="itemName">Other Charges</span><span className="">₹ {Number(otherCharges || 0)}</span></div>
                            {extraPay ? <div className="amount-divider"><span className="itemName">Additional pay</span><span className="">₹ {Number(refund || 0)}</span></div> : ""}
                            <div className="horizontal-line" />
                            <div className="amount-divider"><span className="totalAmount">Total Amount</span><span className="totalAmount">₹ {Number(totalAmount || 0) + Number(details?.booking?.deliveryDetails?.price || 0) + Number(details?.booking?.pickupDetails?.price || 0) + Number(details?.booking?.securityDeposit || 0) + Number(excess || 0) + Number(otherCharges || 0) + (extraPay ? Number(refund || 0) : 0)}</span></div>
                        </div>
                    </CollapseSection>
                    {/* </div> */}
                    {Number(details?.booking?.refund?.amount || 0) > 0 ?
                        <div className="mt-3">
                            <label className="form-label fw-medium">Refund At <span className="text-danger">*</span></label>
                            <div className="datepicker-top">
                                <DatePicker
                                    className="input-theme"
                                    value={(refundAt || details?.booking?.refund?.at) ? new Date(refundAt || details?.booking?.refund?.at) : ""}
                                    onChange={(e) => {
                                        if (!e) return setRefundAt("")
                                        const date = new Date(e);
                                        date.setMinutes(Math.ceil(date.getMinutes() / 5) * 5, 0, 0);
                                        setRefundAt(date.toISOString());
                                    }}
                                    format="DD-MM-YYYY hh:mm A"
                                    plugins={[<TimePicker position="bottom" hideSeconds mStep={5} />]}
                                    disabled={loading}
                                />
                            </div>
                        </div> : ""}
                    <textarea value={verificationRemarks || ""} type="text-area" className="form-control input-theme mt-3" maxLength={500} rows={5} placeholder="Remarks..." onChange={(e) => { setVerificationRemarks(e.target.value) }} />
                    <div className="mt-3 fw-medium">Total Days: {details?.booking?.totalDaysCount || 0}</div>
                    {
                        daysCount?.length === 1 ?
                            <div className="mb-3 mt-2 row align-items-center">
                                <label htmlFor="days" className="form-label col-3">{month[daysCount?.length ? daysCount[0]?.month?.split("-")[1] - 1 : 0]} </label>
                                <div className="col-8">
                                    <input name="days" id="days" autoComplete="off" disabled readOnly className="form-control input-theme text-uppercase col-7" value={details?.booking?.totalDaysCount || 0} />
                                </div>
                            </div>
                            :
                            daysCount?.length ?
                                daysCount?.map((element, key) => {
                                    return (
                                        <div className="mb-3 mt-2 row align-items-center" key={key}>
                                            <label htmlFor={`days${key}`} className="form-label col-3">{month[element?.month?.split("-")[1] - 1]} </label>
                                            <div className="col-8">
                                                <input disabled={loading} name={`days${key}`} id={`days${key}`} autoComplete="off" onChange={(e) => { setDaysCount(daysCount?.map((count) => { if (count?.month === element?.month) count['days'] = e.target.value; return count })); }} className="form-control input-theme text-uppercase col-7" value={element?.days || ""} />
                                            </div>
                                        </div>
                                    )
                                })
                                : ""
                    }
                </div>
                <div className="d-flex align-items-center justify-content-center gap-2 mt-4">
                    <button className="btn btn-success btn-sm px-4" disabled={loading} onClick={verify}>Verify</button>
                    <button className="btn btn-danger btn-sm" disabled={loading} onClick={correction}>Correction</button>
                </div>
            </Modal>
            <div className="verify-border">
                <div className="main-head">
                    <p></p>
                    <p className="head">LESSE INFORMATION SHEET</p>
                    <p className="form-no">Form No: {details?.booking?.formNo}</p>
                </div>
                <div className="row mt-4">
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="customerId" className="col-sm-3 col-form-label view-label">LESSE ID:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input" id="customerId" readOnly value={details?.booking?.customerId || ""} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="type" className="col-sm-3 col-form-label view-label">Type:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input" id="type" readOnly value={details?.booking?.type || ""} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="date" className="col-sm-3 col-form-label view-label">Date:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input" value={details?.booking?.createdAt ? moment(details?.booking?.createdAt)?.format("DD/MM/YYYY") : ""} id="date" readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="name" className="col-sm-3 col-form-label view-label">Name:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input text-capitalize" id="name" readOnly value={(details?.customer?.firstName || "") + " " + (details?.customer?.lastName || "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="mobileNo" className="col-sm-3 col-form-label view-label">Mobile No:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input" value={details?.customer?.phone?.length ? ((details?.customer?.phone?.find(element => element.priority === 1)?.code || "") + "-" + (details?.customer?.phone?.find(element => element.priority === 1)?.phone || "")) : ""} id="mobileNo" readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="altNo1" className="col-sm-3 col-form-label view-label">Alt No1:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input text-capitalize" id="altNo1" readOnly value={details?.customer?.phone?.length ? ((details?.customer?.phone?.find(element => element.priority === 2)?.code || "") + "-" + (details?.customer?.phone?.find(element => element.priority === 2)?.phone || "")) : ""} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="altNo2" className="col-sm-3 col-form-label view-label">Alt No2:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input" value={details?.customer?.phone?.length ? ((details?.customer?.phone?.find(element => element.priority === 3)?.code || "") + "-" + (details?.customer?.phone?.find(element => element.priority === 3)?.phone || "")) : ""} id="altNo2" readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="email" className="col-sm-3 col-form-label view-label">Email:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input" value={details?.customer?.email?.emailId || ""} id="email" readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="mb-2 row">
                            <label htmlFor="address" className="col-sm-3 col-form-label view-label">Current Address:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input text-capitalize" id="address" readOnly value={(details?.customer?.perAddress?.line1 || "") + " " + (details?.customer?.perAddress?.line2 || "") + " " + (details?.customer?.perAddress?.area || "") + " " + (details?.customer?.perAddress?.city || "") + " " + (details?.customer?.perAddress?.state || "") + " " + (details?.customer?.perAddress?.country || "") + " " + (details?.customer?.perAddress?.pincode || "")} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="mb-2 row">
                            <label htmlFor="dest" className="col-sm-3 col-form-label view-label">Travel Destination:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input text-capitalize" id="dest" readOnly value={details?.booking?.pickupDetails?.location || ""} />
                            </div>
                        </div>
                    </div>
                </div>
                <p className="subhead mt-3 mb-1">Trip Details: </p>
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="carmodel" className="col-sm-3 col-form-label view-label">Car Model/Color:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input text-capitalize" id="carmodel" readOnly value={(details?.car?.model || "") + ", " + (details?.car?.color || "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="regNo" className="col-sm-3 col-form-label view-label">Reg. No:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input" value={details?.car?.registrationNo || ""} id="regNo" readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="pickup" className="col-sm-3 col-form-label view-label">Pick Date/Time:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input text-capitalize" id="pickup" readOnly value={(details?.booking?.deliveryDetails?.delivery ? moment(details?.booking?.deliveryDetails?.delivery).format("DD/MM/YYYY hh:mm A") : "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="delivery" className="col-sm-3 col-form-label view-label">Drop Date/Time:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input" value={(details?.booking?.pickupDetails?.pickup ? moment(details?.booking?.pickupDetails?.pickup).format("DD/MM/YYYY hh:mm A") : "")} id="delivery" readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tripstart" className="col-sm-3 col-form-label view-label">Trip Start Kms:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input text-capitalize" id="tripstart" readOnly value={(details?.booking?.km?.start || "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tripend" className="col-sm-3 col-form-label view-label">Trip End Kms:</label>
                            <div className="col-sm-9">
                                <input type="text" id="tripend" className="form-control view-input" value={(details?.booking?.km?.end || "") + " (" + (Number(details?.booking?.km?.end || 0) - Number(details?.booking?.km?.start || 0)) + ")"} readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tripstartfuel" className="col-sm-3 col-form-label view-label">Trip Start Fuel:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input text-capitalize" id="tripstartfuel" readOnly value={(details?.booking?.fuel?.start || "") + " %"} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tripendfuel" className="col-sm-3 col-form-label view-label">Trip End Fuel:</label>
                            <div className="col-sm-9">
                                <input type="text" id="tripendfuel" className="form-control view-input" value={(details?.booking?.fuel?.end || "") + " %"} readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagopen" className="col-sm-5 col-form-label view-label">Tag Open:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="tagopen" readOnly value={(details?.booking?.fastTag?.start || "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagType" className="col-sm-5 col-form-label view-label">Tag Type:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagType" className="form-control view-input" value={(details?.car?.fasTagType || "")} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagend" className="col-sm-5 col-form-label view-label">Tag End:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="tagend" readOnly value={(details?.booking?.fastTag?.end || "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagconsumed" className="col-sm-5 col-form-label view-label">Consumed:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagconsumed" className="form-control view-input" value={(Number(details?.booking?.fastTag?.start || 0) - Number(details?.booking?.fastTag?.end || 0)) > 0 ? (Number(details?.booking?.fastTag?.start || 0) - Number(details?.booking?.fastTag?.end || 0)) : ("+ " + (Number(details?.booking?.fastTag?.end || 0) - Number(details?.booking?.fastTag?.start || 0)))} readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='overflow mt-4'>
                    <table className="table-bg table mb-2 verify-table">
                        <thead>
                            <tr>
                                <th>Driving License Number</th>
                                <th>DL Type</th>
                                <th>Expiry Date</th>
                                <th>Passport No</th>
                                <th>Expiry Date</th>
                                <th>Aadhaar Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{dl?.id || ""}</td>
                                <td>HMV/LMV</td>
                                <td>{dl?.detail?.validTo ? dl?.detail?.validTo : dl?.detail?.dlDate ? dl?.detail?.dlDate : (dl?.dlValidUpto || "")}</td>
                                <td>{passport?.id || ""}</td>
                                <td>{passport?.detail?.passportDate ? passport?.detail?.passportDate : ""}</td>
                                <td>{aadhaar?.id || ""}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="mt-3 mb-1 d-flex align-items-center justify-content-between flex-wrap"> <p className="subhead mb-0">Payment Details: </p> <p className="mb-0 view-label">Package: {details?.booking?.package}</p></div>
                <div className="row">
                    <div className="col-xl-2 col-lg-4">
                        <div className="mb-2 row">
                            <label htmlFor="rent" className="col-sm-5 col-form-label view-label">Amount:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="rent" readOnly value={(details?.booking?.rentalFee || "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2 col-lg-4">
                        <div className="mb-2 row">
                            <label htmlFor="offer" className="col-sm-5 col-form-label view-label">Offer:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input" value={(details?.booking?.offerPerDay || "")} id="offer" readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2 col-lg-4">
                        <div className="mb-2 row">
                            <label htmlFor="final" className="col-sm-5 col-form-label view-label">Final:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="final" readOnly value={(Number(details?.booking?.rentalFee || 0) - Number(details?.booking?.offerPerDay || 0))} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2 col-lg-4">
                        <div className="mb-2 row">
                            <label htmlFor="days" className="col-sm-5 col-form-label view-label">Days:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input" value={(totalDays || 0) + (point?.value || 0)} id="days" readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2 col-lg-4">
                        <div className="mb-2 row">
                            <label htmlFor="total" className="col-sm-5 col-form-label view-label">Total:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="total" readOnly value={totalAmount || 0} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2 col-lg-4">
                        <div className="mb-2 row">
                            <label htmlFor="deposit" className="col-sm-5 col-form-label view-label">Deposit:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input" value={(details?.booking?.securityDeposit || "")} id="deposit" readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="deliveryPrice" className="col-sm-5 col-form-label view-label">Delivery Charges:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="deliveryPrice" readOnly value={(details?.booking?.deliveryDetails?.price || 0)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="delLocation" className="col-sm-5 col-form-label view-label">Location:</label>
                            <div className="col-sm-7">
                                <input type="text" id="delLocation" className="form-control view-input text-capitalize" value={(details?.booking?.deliveryDetails?.location || "")} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="doneBy" className="col-sm-5 col-form-label view-label">Done By:</label>
                            <div className="col-sm-7">
                                <Select
                                    onChange={(selectedoption) => {
                                        setPerson((prev) => ({ ...prev, delivery: selectedoption }))
                                    }}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                            boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                            "&:hover": {
                                                borderColor: "#f16436"
                                            }
                                        }),
                                        option: (style, state) => ({
                                            ...style,
                                            backgroundColor: state.isSelected
                                                ? "#f16436"
                                                : (state.isFocused || state.isActive)
                                                    ? "#f164361a"
                                                    : "white",
                                            color: state.isSelected ? "white" : "black"
                                        })
                                    }}
                                    value={person?.delivery || ""}
                                    options={leadList}
                                    placeholder="Delivery By"
                                />
                                {/* <input type="text" className="form-control view-input text-capitalize" id="doneBy" readOnly value={(details?.booking?.stageHistory?.length ? (details?.booking?.stageHistory?.find(element => element?.stage === "Ongoing")?.subadmin?.name || details?.booking?.stageHistory?.find(element => element?.stage === "Ongoing")?.admin?.name) : "")} /> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="pickupPrice" className="col-sm-5 col-form-label view-label">Pickup Charges:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="pickupPrice" readOnly value={(details?.booking?.pickupDetails?.price || 0)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="pickLocation" className="col-sm-5 col-form-label view-label">Location:</label>
                            <div className="col-sm-7">
                                <input type="text" id="pickLocation" className="form-control view-input text-capitalize" value={(details?.booking?.pickupDetails?.location || "")} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="pickDoneBy" className="col-sm-5 col-form-label view-label">Done By:</label>
                            <div className="col-sm-7">
                                {/* <input type="text" className="form-control view-input text-capitalize" id="pickDoneBy" readOnly value={(details?.booking?.stageHistory?.length ? (details?.booking?.stageHistory?.find(element => element?.stage === "Completed")?.subadmin?.name || details?.booking?.stageHistory?.find(element => element?.stage === "Completed")?.admin?.name) : "")} /> */}
                                <Select
                                    onChange={(selectedoption) => {
                                        setPerson((prev) => ({ ...prev, pickup: selectedoption }))
                                    }}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                            boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                            "&:hover": {
                                                borderColor: "#f16436"
                                            }
                                        }),
                                        option: (style, state) => ({
                                            ...style,
                                            backgroundColor: state.isSelected
                                                ? "#f16436"
                                                : (state.isFocused || state.isActive)
                                                    ? "#f164361a"
                                                    : "white",
                                            color: state.isSelected ? "white" : "black"
                                        })
                                    }}
                                    value={person?.pickup || ""}
                                    options={leadList}
                                    placeholder="Pickup By"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="advance" className="col-sm-5 col-form-label view-label">Advance:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="advance" readOnly value={(details?.booking?.advance?.amount || 0)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="advanceMode" className="col-sm-5 col-form-label view-label">Mode:</label>
                            <div className="col-sm-7">
                                <input type="text" id="advanceMode" className="form-control view-input text-capitalize" value={(details?.booking?.advance?.mode || "")} readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                {
                    details?.booking?.balance?.length ?
                        details?.booking?.balance?.map((element, i) => {
                            return (
                                <div className="row" key={i}>
                                    <div className="col-xl-6 col-lg-6">
                                        <div className="mb-2 row">
                                            <label htmlFor="advance" className="col-sm-5 col-form-label view-label">Bal Amt {i + 1}:</label>
                                            <div className="col-sm-7">
                                                <input type="text" className="form-control view-input text-capitalize" id="advance" readOnly value={(element?.amount || 0)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-6">
                                        <div className="mb-2 row">
                                            <label htmlFor="advanceMode" className="col-sm-5 col-form-label view-label">Mode:</label>
                                            <div className="col-sm-7">
                                                <input type="text" id="advanceMode" className="form-control view-input text-capitalize" value={(element?.mode || "")} readOnly />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                        : ""
                }
                <div className="row">
                    <div className="col-12">
                        <div className="mb-2 row">
                            <label htmlFor="advance" className="col-sm-3 col-form-label view-label">Total Amount Collected:</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control view-input text-capitalize" id="advance" readOnly value={(totalAmount + Number(details?.booking?.securityDeposit || 0) + Number(details?.booking?.deliveryDetails?.price || 0) + Number(details?.booking?.pickupDetails?.price || 0))} />
                            </div>
                        </div>
                    </div>
                </div>
                <p className="subhead mt-3 mb-1">Proof Submitted: </p>
                <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap">
                    <div className="form-check">
                        <input readOnly className="form-check-input" type="checkbox" checked={details?.booking?.proofCollected?.length ? (details?.booking?.proofCollected?.includes("Driving License") || details?.booking?.proofCollected?.includes("dl")) : false} id="dl" />
                        <label className="form-check-label" htmlFor="dl">
                            Driving License
                        </label>
                    </div>
                    <div className="form-check">
                        <input readOnly className="form-check-input" type="checkbox" checked={details?.booking?.proofCollected?.length ? (details?.booking?.proofCollected?.includes("Passport") || details?.booking?.proofCollected?.includes("passport")) : false} id="passport" />
                        <label className="form-check-label" htmlFor="passport">
                            Passport
                        </label>
                    </div>
                    <div className="form-check">
                        <input readOnly className="form-check-input" type="checkbox" checked={details?.booking?.proofCollected?.length ? (details?.booking?.proofCollected?.includes("Voter ID") || details?.booking?.proofCollected?.includes("voter")) : false} id="voter" />
                        <label className="form-check-label" htmlFor="voter">
                            Voter ID
                        </label>
                    </div>
                    <div className="form-check">
                        <input readOnly className="form-check-input" type="checkbox" checked={details?.booking?.proofCollected?.length ? (details?.booking?.proofCollected?.includes("Family Card") || details?.booking?.proofCollected?.includes("familyCard")) : false} id="familyCard" />
                        <label className="form-check-label" htmlFor="familyCard">
                            Family Card
                        </label>
                    </div>
                    <div className="form-check">
                        <input readOnly className="form-check-input" type="checkbox" checked={details?.booking?.proofCollected?.length ? (details?.booking?.proofCollected?.includes("Aadhaar") || details?.booking?.proofCollected?.includes("aadhaar")) : false} id="aadhaar" />
                        <label className="form-check-label" htmlFor="aadhaar">
                            Aadhaar Card
                        </label>
                    </div>
                    <div className="form-check">
                        <input readOnly className="form-check-input" type="checkbox" checked={details?.booking?.proofCollected?.length ? (details?.booking?.proofCollected?.find((element) => element !== "dl" && element !== "Driving License" && element !== "aadhaar" && element !== "Aadhaar" && element !== "passport" && element !== "Passport" && element !== "secDl" && element !== "secAadhaar" && element !== "secPassport" && element !== "voter" && element !== "Voter ID" && element !== "familyCard" && element !== "Family Card")) ? true : false : false} id="other" />
                        <label className="form-check-label" htmlFor="other">
                            Other
                        </label>
                    </div>
                    <div className="row">
                        <label htmlFor="others" className="col-sm-6 col-form-label view-label">Mention Others If Any:</label>
                        <div className="col-sm-6">
                            <input type="text" className="form-control view-input text-capitalize" id="others" readOnly value={(details?.booking?.proofCollected?.find((element) => element !== "dl" && element !== "Driving License" && element !== "aadhaar" && element !== "Aadhaar" && element !== "passport" && element !== "Passport" && element !== "secDl" && element !== "secAadhaar" && element !== "secPassport" && element !== "voter" && element !== "Voter ID" && element !== "familyCard" && element !== "Family Card")) || ""} />
                        </div>
                    </div>
                </div>
                <p className="subhead mt-3 mb-2 office-use">For Office Use Only: </p>
                <div className="row">
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagopen" className="col-sm-5 col-form-label view-label">BTB:</label>
                            <div className="col-sm-7">
                                {/* <input type="text" className="form-control view-input text-capitalize" id="tagopen" readOnly value={details?.booking?.stageHistory?.length ? (details?.booking?.stageHistory?.filter(element => element?.stage === "Booked")?.length ? (details?.booking?.stageHistory?.filter(element => element?.stage === "Booked")[0]?.subadmin?.name || details?.booking?.stageHistory?.filter(element => element?.stage === "Booked")[0]?.admin?.name) : "-") : "-"} /> */}
                                <Select
                                    onChange={(selectedoption) => {
                                        setPerson((prev) => ({ ...prev, booked: selectedoption }))
                                    }}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                            boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                            "&:hover": {
                                                borderColor: "#f16436"
                                            }
                                        }),
                                        option: (style, state) => ({
                                            ...style,
                                            backgroundColor: state.isSelected
                                                ? "#f16436"
                                                : (state.isFocused || state.isActive)
                                                    ? "#f164361a"
                                                    : "white",
                                            color: state.isSelected ? "white" : "black"
                                        })
                                    }}
                                    value={person?.btb || ""}
                                    options={leadList}
                                    placeholder="Booked By"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagType" className="col-sm-5 col-form-label view-label">Src:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagType" className="form-control view-input" value={details?.booking?.lead?.mode || "-"} readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagopen" className="col-sm-5 col-form-label view-label">Excess Kms:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="tagopen" readOnly value={(details?.booking?.excess?.kmDriven || "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagType" className="col-sm-5 col-form-label view-label">Charges:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagType" className="form-control view-input" value={(details?.booking?.excess?.kmCharges || "")} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagend" className="col-sm-5 col-form-label view-label">Excess Fuel:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="tagend" readOnly value={(details?.booking?.excess?.fuelConsumed || "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagconsumed" className="col-sm-5 col-form-label view-label">Charges:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagconsumed" className="form-control view-input" value={details?.booking?.excess?.fuelCharges || ""} readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagopen" className="col-sm-5 col-form-label view-label">Excess Hour:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="tagopen" readOnly value={(details?.booking?.excess?.timeUsed || "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagType" className="col-sm-5 col-form-label view-label">Charges:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagType" className="form-control view-input" value={(details?.booking?.excess?.timeCharges || "")} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagend" className="col-sm-5 col-form-label view-label">Over Speed:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="tagend" readOnly value={(details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "fine")?.amount || 0) : "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagconsumed" className="col-sm-5 col-form-label view-label">Smoking/Drinking:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagconsumed" className="form-control view-input" value={""} readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagopen" className="col-sm-5 col-form-label view-label">Damage Charges:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="tagopen" readOnly value={(details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "damage")?.amount || 0) : "")} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagType" className="col-sm-5 col-form-label view-label">Damage Description:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagType" className="form-control view-input" value={(details?.booking?.excessCharges?.length ? (details?.booking?.excessCharges?.find(element => element?.name === "damage")?.remarks || 0) : "")} readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagopen" className="col-sm-5 col-form-label view-label">Amount:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="tagopen" readOnly value={(((Number(details?.booking?.rentalFee || 0) - Number(details?.booking?.offerPerDay || 0)) * Number(totalDays || 0)) + (point?.value === 0.5 ? ((Number(details?.booking?.rentalFee || 0) / 2) - Number(details?.booking?.halfDayOffer || 0)) : 0)) || 0} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagType" className="col-sm-5 col-form-label view-label">D&P:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagType" className="form-control view-input" value={(Number(details?.booking?.deliveryDetails?.price || 0) + Number(details?.booking?.pickupDetails?.price || 0))} readOnly />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagopen" className="col-sm-5 col-form-label view-label">Excess Usage:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="tagopen" readOnly value={excess} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagType" className="col-sm-5 col-form-label view-label">Other Charges:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagType" className="form-control view-input" value={otherCharges || 0} readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagopen" className="col-sm-5 col-form-label view-label">Total Amount Collected:</label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control view-input text-capitalize" id="tagopen" readOnly value={Number(details?.booking?.totalCostCollected || 0) - Number(details?.booking?.refund?.offer || 0)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="mb-2 row">
                            <label htmlFor="tagType" className="col-sm-5 col-form-label view-label">Refund Amount:</label>
                            <div className="col-sm-7">
                                <input type="text" id="tagType" className="form-control view-input" value={(refund || 0)} readOnly />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-3 text-center"> <button disabled={loading} className="btn btn-success" onClick={() => setPreview(true)}>Verified</button></div>
            </div>
        </React.Fragment>
    )
}

export default Verification